import { Modal } from 'antd';
import { ReactComponent as RemoveImg } from 'assets/icons/x-circle-fill.svg';

export const WebView = ({
    url,
    open,
    onClose,
}: {
    url: string;
    open: boolean;
    onClose?: () => void;
}) => {
    return (
        <Modal
            width={'80%'}
            open={open}
            footer={null}
            centered
            className="modal-info web-view"
            closable={true}
            onCancel={onClose}
            closeIcon={<RemoveImg fill="gray" />}
        >
            <iframe src={url} style={{ paddingBottom: 4, width: '100%', height: '100%' }}></iframe>
        </Modal>
    );
};
